<script>
import Icon from "@smui/textfield/icon";
import LayoutGrid, { Cell } from "@smui/layout-grid";

import Percent from "./Percent.svelte";

export let result = undefined;

const invoiceAmount = result["invoiceAmount"];
const travellingExpenses = result["travellingExpenses"];
const travellingExpensesAcceptable = invoiceAmount * 15 /100;
const percentActual = travellingExpenses / invoiceAmount;

let isWarning = false;

if(travellingExpenses > travellingExpensesAcceptable) {
  isWarning = true;
}

let color = "black";
let weight = "normal";
if (percentActual*100 > 20) {
    color = "red";
    weight = "bold";
} else if(percentActual*100 > 15){
    color = "orange"
    weight = "bold";
}

</script>
{#if travellingExpenses > 0}
<LayoutGrid style="display: flex; align-items: center; gap: 0.5rem;padding-left: 0;padding-right: 0;">
    <Cell span={12} class="resume-salary">
        {#if isWarning}
            <Icon class="material-icons" slot="trailingIcon" style="vertical-align: middle;font-size: 1.2rem;font-weight:{weight};color: {color};">warning</Icon>
        {/if}
        <span>Frais optimisables : <Percent number={percentActual} /></span>
    </Cell>
</LayoutGrid>
{/if}